import axios from "axios";
import { UrlApi } from "../Keys";

const dataInicial = {
    unidadOrganizativa: [],
    loadingUnidad: false,
    posiciones: [],
    loadingPosiciones: false,
    posicionesBDGT: [],
    loadingPosicionesBDGT: false,
    empleados: [],
    loadingEmpleados: false,
};

const LOADING_UNIDAD_ORGANIZATIVA = 'LOADING_UNIDAD_ORGANIZATIVA'
const UNIDAD_ORGANIZATIVA = 'UNIDAD_ORGANIZATIVA'
const UNIDAD_ORGANIZATIVA_ERROR = 'UNIDAD_ORGANIZATIVA_ERROR'

const LOADING_POSICIONES = 'LOADING_POSICIONES'
const POSICIONES = 'POSICIONES'
const POSICIONES_ERROR = 'POSICIONES_ERROR'

const LOADING_EMPLEADOS = 'LOADING_EMPLEADOS'
const EMPLEADOS = 'EMPLEADOS'
const EMPLEADOS_ERROR = 'EMPLEADOS_ERROR'

const POSICIONESBDGT_LOADING = 'POSICIONESBDGT_LOADING'
const POSICIONESBDGT = 'POSICIONESBDGT'
const POSICIONESBDGT_ERROR = 'POSICIONESBDGT_ERROR'

//Reducers
export default function organigramaReducer(state = dataInicial, action) {
    switch (action.type) {
        case LOADING_UNIDAD_ORGANIZATIVA:
            return { ...state, loadingUnidad: action.loadingUnidad };
        case UNIDAD_ORGANIZATIVA:
            return { ...state, unidadOrganizativa: action.payload, loadingUnidad: action.loadingUnidad };
        case UNIDAD_ORGANIZATIVA_ERROR:
            return { ...state, loadingUnidad: action.loadingUnidad };
        case LOADING_POSICIONES:
            return { ...state, loadingPosiciones: action.loadingPosiciones };
        case POSICIONES:
            return { ...state, posiciones: action.payload, loadingPosiciones: action.loadingPosiciones };
        case POSICIONES_ERROR:
            return { ...state, loadingPosiciones: action.loadingPosiciones };
        case POSICIONESBDGT_LOADING:
            return { ...state, loadingPosicionesBDGT: action.loadingPosicionesBDGT };
        case POSICIONESBDGT:
            return { ...state, posicionesBDGT: action.payload, loadingPosicionesBDGT: action.loadingPosicionesBDGT };
        case POSICIONESBDGT_ERROR:
            return { ...state, loadingPosicionesBDGT: action.loadingPosicionesBDGT };
        case LOADING_EMPLEADOS:
            return { ...state, loadingEmpleados: action.loadingEmpleados };
        case EMPLEADOS:
            return { ...state, empleados: action.payload, loadingEmpleados: action.loadingEmpleados };
        case EMPLEADOS_ERROR:
            return { ...state, loadingEmpleados: action.loadingEmpleados };
        default:
            return { ...state };
    }
}

export const unidadOrganizativa = (token) => async (dispatch) => {
    dispatch({
        type: LOADING_UNIDAD_ORGANIZATIVA,
        loadingUnidad: true,
    });

    try {
        var entidad = "new_unidadorganigramas";
        var fetch = `
        <entity name="new_unidadorganigrama">
        <attribute name="new_name"/>
        <attribute name="new_unidadsuperior"/>
        <attribute name="new_idunidadorganigrama"/>
        <attribute name="new_tipo"/>
        <attribute name="new_fechainicio"/>
        <attribute name="new_fechafin"/>
        <attribute name="new_empresa"/>
        <attribute name="new_gerencia"/>
        <attribute name="new_direccion"/>
        <attribute name="new_unidadorganigramaid"/>
        <order attribute="new_tipo" descending="false"/>
        <filter type="and">
        <condition attribute="statecode" operator="eq" value="0"/>
        </filter>
        <link-entity name="new_posicion" from="new_unidadorganizativa" to="new_unidadorganigramaid" link-type="inner" alias="ae">
        <filter type="and">
        <filter type="or">
        <condition attribute="new_posiciondocente" operator="eq" value="0"/>
        <condition attribute="new_posiciondocente" operator="null"/>
        </filter>
        </filter>
        </link-entity>
        </entity>`

        const response = await axios.post(
            `${UrlApi}api/consultafetch`,
            {
                entidad: entidad,
                fetch: fetch,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        dispatch({
            type: UNIDAD_ORGANIZATIVA,
            payload: response.data,
            loadingUnidad: false,
        });
    } catch (error) {
        dispatch({
            type: UNIDAD_ORGANIZATIVA_ERROR,
            loadingUnidad: false,
        });
    } finally {
        dispatch({
            type: LOADING_UNIDAD_ORGANIZATIVA,
            loadingUnidad: false,
        });
    }
};

export const posiciones = (token) => async (dispatch) => {
    dispatch({
        type: LOADING_POSICIONES,
        loadingPosiciones: true,
    });

    try {
        var entidad = "new_posicions";
        var fetch = `
        <entity name="new_posicion">
          <attribute name="new_posicionid" />
          <attribute name="new_name" />
          <attribute name="createdon" />
          <attribute name="new_grupopersonal" />
          <attribute name="new_reportaa" />
          <attribute name="new_idposicin" />
          <attribute name="new_empleadoactual" />
          <attribute name="statuscode" />
          <order attribute="new_name" descending="false" />
          <filter type="and">
            <condition attribute="new_grupopersonal" operator="in">
              <value>100000002</value>
              <value>100000007</value>
              <value>100000000</value>
              <value>100000003</value>
            </condition>
            <condition attribute="statecode" operator="eq" value="0" />
          </filter>
        </entity>`

        const response = await axios.post(
            `${UrlApi}api/consultafetch`,
            {
                entidad: entidad,
                fetch: fetch,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        dispatch({
            type: POSICIONES,
            payload: response.data,
            loadingPosiciones: false,
        });
    } catch (error) {
        dispatch({
            type: POSICIONES_ERROR,
            loadingPosiciones: false,
        });
    } finally {
        dispatch({
            type: LOADING_POSICIONES,
            loadingPosiciones: false,
        });
    }
};

export const empleadosOrgFETCH = (token, id) => async (dispatch) => {
    dispatch({
        type: LOADING_EMPLEADOS,
        loadingEmpleados: true,
    });

    try {
        var entidad = "new_empleados";
        var fetch = `
        <entity name="new_empleado">
          <attribute name="new_name" />
          <attribute name="new_cuitcuil" />
          <attribute name="new_correoelectronico" />
          <attribute name="new_numerolegajo" />
          <attribute name="new_reportaaid" />
          <attribute name="new_empleadoid" />
          <attribute name="new_posicin" />
          <order attribute="new_numerolegajo" descending="false" />
          <link-entity name="new_unidadorganigrama" from="new_unidadorganigramaid" to="new_unidadorganizativa" link-type="inner" alias="ag">
            <filter type="and">
              <condition attribute="new_unidadorganigramaid" operator="eq-or-under" uitype="new_unidadorganigrama" value="${id}" />
            </filter>
          </link-entity>
        </entity>`

        const response = await axios.post(
            `${UrlApi}api/consultafetch`,
            {
                entidad: entidad,
                fetch: fetch,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        dispatch({
            type: EMPLEADOS,
            payload: response.data,
            loadingEmpleados: false,
        });
    } catch (error) {
        console.log(error)
        dispatch({
            type: EMPLEADOS_ERROR,
            loadingEmpleados: false,
        });
    } finally {
        dispatch({
            type: LOADING_EMPLEADOS,
            loadingEmpleados: false,
        });
    }
};

export const posicionesBDGT = (token, new_gerencia, new_secretaria, new_direccion) => async (dispatch) => {
    dispatch({
        type: POSICIONESBDGT_LOADING,
        loadingPosicionesBDGT: true,
    });


    let additionalFilters = '';

    if (new_gerencia) {
        additionalFilters += `
            <condition attribute="new_gerencia" operator="eq" uitype="new_unidadorganigrama" value="${new_gerencia}"/>
        `;
    }

    if (new_secretaria) {
        additionalFilters += `
            <condition attribute="new_secretaria" operator="eq" uitype="new_unidadorganigrama" value="${new_secretaria}"/>
        `;
    }

    if (new_direccion) {
        additionalFilters += `
            <condition attribute="new_direccion" operator="eq" uitype="new_unidadorganigrama" value="${new_direccion}"/>
        `;
    }

    try {
        var entidad = "new_posicions";
        var fetch = `
        <entity name="new_posicion">
            <attribute name="new_posicionid" />
            <attribute name="new_name" />
            <attribute name="new_reportaa" />
            <attribute name="new_idposicin" />
            <attribute name="new_fechainicio" />
            <attribute name="new_fechafin" />
            <attribute name="new_empresa" />
            <attribute name="new_unidadorganizativa" />
            <attribute name="statuscode" />
            <attribute name="new_nivel" />
            <attribute name="new_modalidaddetrabajo" />
            <attribute name="new_empleadoactual" />
            <attribute name="createdon" />
            <attribute name="new_grupopersonal" />
            <attribute name="new_empleadoactual" />
            <order attribute="new_name" descending="false" />
            <filter type="and">
                <condition attribute="new_name" operator="ne" value="DOCENTE"/>
                <condition attribute="new_name" operator="not-like" value="%TMP%"/>
                <condition attribute="new_name" operator="not-like" value="%Contenidos%"/>
                <condition attribute="new_name" operator="not-like" value="%Pasante%"/>
                <condition attribute="statuscode" operator="in">
                    <value>100000000</value>
                    <value>1</value>
                </condition>
                <condition attribute="new_unidadorganizativa" operator="not-in">
                    <value uiname="CORPORATIVO" uitype="new_unidadorganigrama">{326898EA-558E-EB11-B1AC-0022483729C4}</value>
                    <value uiname="UNIDAD AGROPECUARIA" uitype="new_unidadorganigrama">{388AC53C-6BA1-EB11-B1AC-0022483740AC}</value>
                </condition>
            </filter>
            <link-entity name="new_unidadorganigrama" from="new_unidadorganigramaid" to="new_unidadorganizativa" link-type="inner" alias="ab">
                <attribute name="new_gerencia" />
                <attribute name="new_secretaria" />
                <attribute name="new_direccion" />
                <filter type="and">
                    ${additionalFilters}
                </filter>
            </link-entity>
            <link-entity name="new_empleado" from="new_empleadoid" to="new_empleadoactual" link-type="outer" alias="ac">
                <attribute name="new_numerolegajo" />
            </link-entity>
            <link-entity name="new_posicion" from="new_posicionid" to="new_reportaa" link-type="outer" alias="ad">
                <attribute name="new_name" />
                <attribute name="new_empleadoactual" />
                <attribute name="new_reportaa" />
                <link-entity name="new_posicion" from="new_posicionid" to="new_reportaa" link-type="outer" alias="ae">
                    <attribute name="new_name" />
                    <attribute name="new_empleadoactual" />
                </link-entity>
            </link-entity>
        </entity>`

        const response = await axios.post(
            `${UrlApi}api/consultafetch`,
            {
                entidad: entidad,
                fetch: fetch,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        dispatch({
            type: POSICIONESBDGT,
            payload: response.data,
            loadingPosicionesBDGT: false,
        });
    } catch (error) {
        dispatch({
            type: POSICIONESBDGT_ERROR,
            loadingPosicionesBDGT: false,
        });
    } finally {
        dispatch({
            type: POSICIONESBDGT_LOADING,
            loadingPosicionesBDGT: false,
        });
    }
};